import { render, staticRenderFns } from "./SupervisionUsersDashboard.vue?vue&type=template&id=20b4097c&"
import script from "./SupervisionUsersDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisionUsersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports